import { create } from "zustand";

interface FirstLoaderState {
  progress: number;
  showFirstLoader: boolean;
  setProgress: (value: number | ((prev: number) => number)) => void;
  setShowFirstLoader: (value: boolean) => void;
}

export const useFirstLoader = create<FirstLoaderState>((set) => ({
  progress: 0,
  showFirstLoader: true,
  setProgress: (value) =>
    set((state) => ({
      progress: typeof value === "function" ? value(state.progress) : value,
    })),
  setShowFirstLoader: (value) => set({ showFirstLoader: value }),
}));
